import { map } from 'lodash'

const transformToUpdateIngredientOverridesIngredientsDetailsArgs = data =>
  map(data?.overridesIngredientIds, 'value')

export default transformToUpdateIngredientOverridesIngredientsDetailsArgs
